export { default } from "./CBDStoresCarousel";
